// extracted by mini-css-extract-plugin
export default {"box":"Cases_box__R1E-4","description":"Cases_description__+nMjH","text":"Cases_text__C3bB+","title":"Cases_title__af1Dj","boxItem":"Cases_boxItem__6JUZg","img":"Cases_img__Onz7i"};